export default "__VITE_ASSET__C$iR6l6C__"